import { render, staticRenderFns } from "./ClosuresCalendar.vue?vue&type=template&id=0e19c046"
import script from "./ClosuresCalendar.vue?vue&type=script&lang=ts"
export * from "./ClosuresCalendar.vue?vue&type=script&lang=ts"
import style0 from "./ClosuresCalendar.vue?vue&type=style&index=0&id=0e19c046&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports